import type { Entity } from '../components'

// Autophagy adaptation (amoeba-unification.md): regen scales with card level.
export function regenSystem(player: Entity, dt: number): void {
  if (!player.health) return
  const rate = player.mods?.regenRate ?? 0
  if (rate <= 0) return
  player.health.current = Math.min(player.health.max, player.health.current + rate * dt)
}
